// extracted by mini-css-extract-plugin
export default {"mCard":"cz-z","image":"dz-z","imageNoBackground":"ez-z","imageHasCategory":"fz-z","fullWidth":"gz-z"};